import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '../../../shared/components/button/button.component';

@Component({
    selector: 'wci-navbar',
    imports: [RouterLink, ButtonComponent],
    templateUrl: './navbar.component.html',
    styles: ``,
})
export class NavbarComponent {}
